/**
 * @file    FilterIcon.tsx
 * @scope   VIEW
 * @summary Diy Enterprise filter indicator shown next to the metric (field_1). Swaps to the
 *          "applied" icon on hover (CSS) and lists the active filters in a tooltip.
 * @consumes appAssets icons, Tippy
 * @produces JSX only
 * @sideEffects None.
 */
import React from 'react';
import Tippy from '@tippyjs/react';
import { appAssets } from 'constants/assets';

const FilterIconNotApplied = appAssets.icons.FILTERNOTAPPLIED;
const FilterIconApplied = appAssets.icons.FILTERAPPLIED;

const stop = (e: React.SyntheticEvent) => e.stopPropagation();

const FilterIcon: React.FC<{ tooltip: string }> = ({ tooltip }) => (
  <Tippy
    content={<div className="tooltip-title dynamic-table-filter-tooltip">{tooltip}</div>}
    placement="right"
    interactive={false}
    appendTo="parent"
  >
    <span className="dynamic-table-filter-icon" onMouseEnter={stop} onMouseOver={stop}>
      <span className="filter-icon-default">
        <FilterIconNotApplied />
      </span>
      <span className="filter-icon-hover">
        <FilterIconApplied />
      </span>
    </span>
  </Tippy>
);

export default React.memo(FilterIcon);
